import {NDVSClient} from "../../client/NDVSClient";
import {PrintLabelSheetActions} from "../actions/PrintLabelSheetActions";
import {PrintLabelErrorMessages} from "../constants/PrintLabelErrorMessages";

export function printLabelSheet(trackingIds, dispatcher) {
    NDVSClient.printLabelSheet({
        trackingIds : trackingIds
    }).then(({valid, data}) => {
        if (valid) {
            try {
                const base64String = data.printLabelSheetPdf;
                const blob = base64toBlob(base64String);

                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            } catch (e) {
                dispatcher({
                    type: PrintLabelSheetActions.PRINT_LABEL_SHEET_ERROR_RESPONSE,
                    msg: PrintLabelErrorMessages.ERROR_WHILE_GENERATING_PDF
                })
            }
            dispatcher({
                type: PrintLabelSheetActions.PRINT_LABEL_SHEET_RESPONSE
            })
        } else {
            dispatcher({
                type: PrintLabelSheetActions.PRINT_LABEL_SHEET_ERROR_RESPONSE,
                msg: PrintLabelErrorMessages.ERROR_WHILE_FETCHING_LABEL
            })
        }
    });
}

const base64toBlob = (base64WithoutPrefix) => {
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: 'application/pdf'});
};




// WEBPACK FOOTER //
// ./src/components/labelSheet/network/PrintLabelSheetAPI.js